let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7F9PY")).then(() => parcelRequire('azR8x'));